import BillingHTTP from 'utils/billing-http';
import Promise from 'bluebird';

class BoletoService {
  getBoletoBillPayment(billingId, billId) {
    return BillingHTTP
      .getContent(`/dashboard-api/v2/billings/${billingId}/bills/${billId}/bill-payments/boleto-bill-payment`);
  }

  tryBoletoBillPayment(billingId, billId) {
    return new Promise((resolve, reject) => {
      this.getBoletoBillPayment(billingId, billId)
        .then((response) => {
          this.treatResponse(response, billingId, billId, resolve);
        })
        .catch(() => reject);
    });
  }

  createBoletoBillPayment(billingId, billId) {
    return new Promise((resolve, reject) => {
      BillingHTTP.postContent(
        `/dashboard-api/v2/billings/${billingId}/bills/${billId}/bill-payments`, { payment_method: 'boleto' },
      )
        .then(() => this.pollForBoletoBillPayment(billingId, billId, resolve))
        .catch(() => reject);
    });
  }

  pollForBoletoBillPayment(billingId, billId, resolve) {
    setTimeout(() => {
      this.getBoletoBillPayment(billingId, billId)
        .then((response) => {
          this.treatResponse(response, billingId, billId, resolve);
        });
    }, 1000);
  }

  treatResponse(response, billingId, billId, resolve) {
    if (response === null || response.bar_code === null) {
      this.pollForBoletoBillPayment(billingId, billId, resolve);
    } else {
      resolve(response);
    }
  }

  downloadBoleto(billPaymentId, fileName) {
    return BillingHTTP.downloadPdf(
      `/dashboard-api/v2/bill-payments/${billPaymentId}/download-boleto`,
      fileName,
    );
  }

  downloadPromiseBoleto(paymentPromiseId, fileName) {
    return BillingHTTP.downloadPdf(
      `/dashboard-api/v2/payment-promises/${paymentPromiseId}/download-boleto`,
      fileName,
    );
  }
}

export default new BoletoService();
